<template>
  <div class="modal-container" v-if="visible">
    <div class="modal-overlay"></div>
    <div class="modal-content" :style="modalWidth">
      <div class="modal-header">
        <div>
          <dx-text v-if="title" size="lg" weight="bolder" color="blue">{{ title }}</dx-text>
        </div>
        <div class="dx-flex-direction--row dx-align-items--center">
          <div class="dx-margin-right--md">
            <slot name="right-header"></slot>
          </div>
          <div class="action-icon" @click="closeModal" @keyDown="closeModal">
            <dx-icon icon="times" />
          </div>
      </div>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { propValidationService } from '../functions';

library.add(faTimes);

const SIZE_TYPES = [{ key: 'sm' }, { key: 'md' }, { key: 'lg' }];

export default {
  name: 'dx-modal',

  props: {
    title: String,
    visible: Boolean,
    size: {
      default: 'sm',
      type: String,
      validator: propValidationService.buildValidator({
        validValues: SIZE_TYPES.map((attr) => attr.key),
        errorMessage: 'You should inform a valid size',
      }),
    },
  },
  computed: {
    modalWidth() {
      const sizes = {
        sm: '35%',
        md: '60%',
        lg: '98%',
      };

      return this.size === 'lg' ? `width: ${sizes[this.size]}; height: 95%;` : `width: ${sizes[this.size]}`;
    },
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 1;
  background-color: var(--dx-color--white);
  padding: 20px;
  border-radius: 5px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.modal-header .action-icon {
  border: none;
  background-color: transparent;
  font-size: 20px;
  padding-right: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.modal-body {
  padding: 10px 0;
  height: -webkit-fill-available;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
